<template>
    <div>
        <div  class="" style="background: #FAFAFA; padding-bottom: 30px;">
            <div class="container">
                <div class="d-flex justify-content-between align-items-baseline">
                    <h3 class="bills-text"><span class="fa fa-chevron-left" @click="goback()"></span>TV/Cable Network</h3>
                    <h5 class="history-text" @click="routeTo('/dashboard/bills-history')">History</h5>
                </div>

                <div class="provider-holder">
                    <div class="custom-dropdown">
                        <label for="provider">Service providers</label>
                        <div class="selected-option" id="provider" @click.stop="togglePanelProvider">
                            <img :src="imgScr" alt="" id="current-flag">
                            <span id="current-name">{{ optionData == '' ? 'Select Provider': optionData }}</span>
                            <!-- <span><i class="fa fa-chevron-right"></i></span> -->
                        </div>

                        <!-- The hidden panel of countries -->
                        <ul class="options-panel" id="provider" v-if="providerPanel">
                            <li @click="selectProvider('dstv', '../../assets/billpayment/DSTV.svg')">
                                <img src="../../assets/billpayment/DSTV.svg" alt=""> DSTV
                            </li>
                            <li @click="selectProvider('gotv', '../../assets/billpayment/GOTV.svg')">
                                <img style="width: 32px;" src="../../assets/billpayment/GOTV.svg" alt=""> GOTV
                            </li>
                            <li @click="selectProvider('startimes', '../../assets/billpayment/STARTIMES.svg')">
                                <img src="../../assets/billpayment/STARTIMES.svg" alt="">  STARTIMES
                            </li>
                            <!-- <li @click="selectProvider('SHOWMAX', '../../assets/billpayment/SHOWMAX.svg')">
                                <img src="../../assets/billpayment/SHOWMAX.svg" alt="">  SHOWMAX
                            </li> -->
                            
                            
                        </ul>
                    </div>
                    <hr>
                    <div class="custom-dropdown">
                        <label for="package">Package</label>
                        <div class="selected-option" @click.stop="togglePanelPackage">
                            <img :src="imgScr" alt="" id="current-package">
                            <span id="current-name">{{ package == '' ? 'Select package': package }}</span>
                        </div>

                        <!-- The hidden panel of countries -->
                        <ul class="options-panel" id="package" v-if="packagePanel && optionData != ''">
                            <li @click="selectPackage('PREPAID')">
                                <img :src="imgScr" alt=""> PREPAID
                            </li>
                            <li @click="selectPackage('POSTPAID')">
                                <img :src="imgScr" alt=""> POSTPAID
                            </li>
                            
                        </ul>
                    </div>
                    <hr>
                    <div class="form-group">
                        <div class="beneficiries">
                            <label for="phonenumber">Phone number</label>
                        </div>
                        <input v-model="phoneNumber"  minlength="11" maxlength="11" pattern="[0-9]{11}" type="tel" id="phonenumber" class="form-control" placeholder="Enter phone number">
                    </div>
                    <hr>
                    <div class="form-group">
                        <div class="beneficiries">
                            <label for="smartcard">Decoder number</label>
                            <span data-toggle="modal" data-target="#beneficiaryList" @click="checkBeneficaries()">Beneficiaries <i class="fa fa-cheveron-right"></i></span>
                        </div>
                        <div class="verify-smartcard">
                            <input v-model="decoderNumber" type="number" id="smartcard" class="form-control" placeholder="Enter decoder number">
                            <button :disabled="package == '' || optionData == '' || decoderNumber == '' || loading" class="btn" @click="verifySmartCardNumber(); finalCheck = false;">
                                <span v-if="!loading">Validate</span>
                                <i
                                class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                                v-if="loading"
                                ></i>
                            </button>
                        </div>
                        <div class="verify-data">
                            <h4>{{verifiedData.name}}</h4>
                        </div>
                        <div class="ben-holder">
                            <!-- <input type="checkbox" id="savebeneficiaris" class="form-control" true-value="yes"
                                false-value="no" v-model="savebeneficiary"> -->
                            <label for="savebeneficiaris" @click="saveBeneficiaryDetails()" style="cursor: pointer;">Save Beneficiary</label>
                        </div>
                    </div>
                </div>
                <div class="provider-holder mt-4" v-if="tvPackages.length > 0 && !loading">
                    <label class>Hot deals</label>
                    <div class="row">
                        <div class="col-md-3" v-for="(item, index) in tvPackages"
                              :key="index">
                            <div class="deals-holder" :class="[dealsIndex === index ? 'activeDeals' : '']" @click="dealsItem(item, index)">
                                <div>
                                    <h6>{{item.name}}</h6>
                                    <h5>₦{{Number(item.amount).toLocaleString()}}</h5>
                                </div>
                                <div>
                                    <p>{{item.time_unit_duration}}</p>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-md-3">
                            <div class="deals-holder">
                                <div>
                                    <h6>Gotv Lite</h6>
                                    <h5>₦8500</h5>
                                </div>
                                <div>
                                    <p>1 Month</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="deals-holder">
                                <div>
                                    <h6>Gotv Lite</h6>
                                    <h5>₦8500</h5>
                                </div>
                                <div>
                                    <p>1 Month</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="deals-holder">
                                <div>
                                    <h6>Gotv Lite</h6>
                                    <h5>₦8500</h5>
                                </div>
                                <div>
                                    <p>1 Month</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="deals-holder">
                                <div>
                                    <h6>Gotv Lite</h6>
                                    <h5>₦8500</h5>
                                </div>
                                <div>
                                    <p>1 Month</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="deals-holder">
                                <div>
                                    <h6>Gotv Lite</h6>
                                    <h5>₦8500</h5>
                                </div>
                                <div>
                                    <p>1 Month</p>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>

                <div class="payment-method-holder">
                    <label for="paymentmethod">Select Payment Method</label>
                    <div class="paymentOfPayment" id="paymentmethod">
                        <div class="" style="position: relative;">
                            <!-- <div class="payment-item col-md-6" @click="paymentType = 'paystack'" :class="[paymentType == 'paystack' ? 'active-payment' : '']">
                                <img src="../../assets/billpayment/paystack.svg" alt="paystack">
                                <h6>Pay with Paystack</h6>
                            </div> -->
                            <div class="payment-item col-md-6" @click="paymentType = 'safe'" :class="[paymentType == 'safe' ? 'active-payment' : '']">
                                <img src="../../assets/billpayment/safe-logo.svg" alt="safe">
                                <div>
                                    <h6>Pay with SAFE</h6>
                                    <p>Available balance: <span>₦{{ Number(safeDetails.balance || 0).toLocaleString() }}</span></p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="submitPayment">
                        <button class="btn" @click="openConfirmation(); finalCheck = true; ">Continue</button>
                    </div>
                    <confirmPayment @call-parent="buyCableTv" ref="confirmModalBill"   />
                    <succesfulPayment :billdata="billObject" @call-parent="buyCableTv" ref="successfulPaymentMade"  />
                </div>
            </div>
        </div>
         <!-- Beneficiary List -->
         <div class="modal fade" id="beneficiaryListId" tabindex="-1" role="dialog" aria-labelledby="beneficiaryListId" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title title-modal" id="exampleModalLongTitle">Beneficiaries</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group" v-if="beneficiaries.length > 0">
                            <ul>
                                <li>Select beneficiary</li>
                                <li  v-for="(item, index) in beneficiaries" @click.stop="selectBeneficiary(item)"
                              :key="index">{{ item.bill_identifier }}</li>
                            </ul>
                        </div>
                        <p v-else>
                            No beneficiary added.
                        </p>
                    </div>
                    
                    </div>
                </div>
            </div>
            <!-- Beneficiary List -->
        <div v-if="loading">
            <PageLoader></PageLoader>
        </div>
    </div>
</template>

<script>
import confirmPayment from './ConfirmPayment.vue';
import succesfulPayment from './SuccessfulPayment.vue';
import { Service } from "../../store/service";
import PageLoader from "../../components/PageLoader.vue";
import $ from "jquery";
const Api = new Service();
export default {
    name: "TvCable",
    components: {
        confirmPayment,
        succesfulPayment,
        PageLoader
    },
    data() {
        return {
            loading: false,
            imgScr: "",
            optionData: "",
            providerPanel: false,
            packagePanel: false,
            paymentType: "safe",
            billObject: {},
            savebeneficiary: 'no',
            tvPackages: [],
            dealsIndex: null,
            package: "",
            phoneNumber: "",
            smartCardNumber: "",
            decoderNumber: "",
            signleDeal: "",
            coverPoint: 100,
            verifiedData: "",
            statutoryCharge: null,
            finalCheck: false,
            beneficiaries: [],
            beneficiarySelected: "",
            rewardObject: "",
            safeDetails: "",
        }
    },
    mounted() {
        // Add listener when component is mounted
        document.addEventListener('click', this.close);
        document.addEventListener('click', this.close2);
        this.getBeneficiary();
        this.fetchReward();
    },
    beforeDestroy() {
        // Crucial: remove listener to prevent memory leaks
        document.removeEventListener('click', this.close);
        document.removeEventListener('click', this.close2);
    },
    methods: {
        routeTo(route) {
            this.$router.push({
            path: route
            })
            .catch(() => {});
        },
        goback() {
            window.history.length > 1 ? this.$router.back() : this.$router.push('/dashboard/bills-payment')
        },
        selectProvider(title, srcImg) {
            const fullPath = srcImg;
            const filename = fullPath.split('/').pop(); 
            this.optionData = title;
            this.imgScr = require( `../../assets/billpayment/${filename}`);
            // console.log("Image source", srcImg)
            this.fetchTvPackages();
        },
        togglePanelProvider() {
            this.providerPanel = !this.providerPanel;
        },
        close(e) {
            // Check if the click was outside this component's root element
            if (this.$el.contains(e.target)) {
                this.providerPanel = false;
            }
        },
        selectPackage(item) {
            this.package = item;
        },
        togglePanelPackage() {
            this.packagePanel = !this.packagePanel;
        },
        close2(e) {
            // Check if the click was outside this component's root element
            if (this.$el.contains(e.target)) {
                this.packagePanel = false;
            }
        },
        dealsItem(item, index) {
            this.dealsIndex = index;
            this.signleDeal = item;
        },
        async fetchTvPackages() {
            this.loading = true
            try {
                await Api.postRequest(`fetch-tv-packages`, {cable_type: this.optionData})
                .then(res => {
                this.loading = false;
                // console.log("TV packages", res)
                if (res.data.error) {
                    return this.$store.commit("setApiFailed", res.data.error);
                }
                if (res.data.success) {
                    this.tvPackages = res.data.data;
                }
                })
                .catch(err => {
                    // this.loader2 = false;
                    console.log("ERROR", err);
                    this.loading = false;
                });
            } finally {
            // console.log("Closed connection");
            }
        },
        saveBeneficiaryDetails() {
            if (this.decoderNumber == '') {
                return this.$store.commit("setApiFailed", "Enter decoder number");
            }
            Api.postRequest(`save-user-bill-data`, {
                bill_type: "tv",
                bill_identifier: this.decoderNumber,
            }).then((res) => {
                // console.log("beneficiary saved", res);
                // this.$store.commit("setApiSuccess", "Beneficiary added successfuly");
            }).catch(err => {
                console.log("ERROR", err);
                this.loading = false;
            });
        },
        getBeneficiary() {
            Api.postRequest(`fetch-user-bill-data-by-bill-type`, {type: 'tv'}).then((res) => {
                // console.log("fetch beneficiary", res);
                if(res.data.success) {
                    const duplicated = res.data.data;
                    // this.beneficiaries = [...new Set(duplicated)];
                    this.beneficiaries = [...new Map(duplicated.map(item => [item.bill_identifier, item])).values()]
                    // console.log("Duplicated", this.beneficiaries);
                }
            }).catch(err => {
                console.log("ERROR", err);
            });
        },
        checkBeneficaries() {
            $("#beneficiaryListId")
                .addClass("fade")
                .modal("show");
        },
        selectBeneficiary(item) {
            this.decoderNumber = item.bill_identifier;
            // console.log("change item", item)
            this.$nextTick(() => {
                $('#beneficiaryListId').modal('hide');
            });
            
        },
        async verifySmartCardNumber() {
            if (this.decoderNumber == "") {
                return this.$store.commit("setApiFailed", "Enter decoder number");
            }
            if (this.package == "") {
                return this.$store.commit("setApiFailed", "Select package");
            }
            if (this.optionData == "") {
                return this.$store.commit("setApiFailed", "Select disco");
            }
            this.loading = true;
            
            const payload = {
                cable_type: (this.optionData).toLowerCase(),
                vend_type: this.package,
                decoder_no: this.decoderNumber,
                phone: this.phoneNumber,
            }
            try {
                await Api.postRequest(`validate-customer`, JSON.stringify(payload))
                    .then(res => {
                        console.log("Smart card details verification", res)
                        this.loading = false;
                        if (res.data.error) {
                            this.verifiedData = "";
                            return this.$store.commit("setApiFailed", res.data.error);
                        }
                        if (res.data.success) {
                            this.verifiedData = res.data.data;
                            this.statutoryCharge = res.data.statutory_charge;
                            if(this.finalCheck == true) {
                                this.confirmatiomModalValidation();
                            } else {
                                this.$store.commit("setApiSuccess", "success");
                            }
                        }
                    })
                    .catch(err => {
                        console.log("ERROR", err);
                        this.loading = false;
                    });
            } finally {
                    // console.log("closed") 
            }
        },
        async buyCableTv(messageFromParent) {
            $("#confirmPaymentBill")
            .removeClass("fade")
            .modal("hide");
            this.loading = true
            const payload = {
                mode_of_payment: this.paymentType,
                cable_type: this.optionData,
                vend_type: this.package,
                phone: this.phoneNumber,
                amount: Number(this.signleDeal.amount),
                decoder_no: this.decoderNumber,
                statutory_charge: 100, //this.statutoryCharge,
                code: this.signleDeal.code,
                cova_points: this.coverPoint,
            }
            try {
                await Api.postRequest(`pay-for-tv-subscription`, JSON.stringify(payload))
                .then(res => {
                    // console.log("puchase data:", res);
                    if(res.data.requery == 'yes') {
                        this.loading = true;
                        return this.requery(res.data.requery_id)
                    }
                    this.loading = false;
                    if (res.data.error) {
                        return this.$store.commit("setApiFailed", res.data.error);
                    }
                    if (res.data.success) {
                        this.loading = false;
                        this.billsHook();
                        this.$store.commit("setApiSuccess", "success");
                        res.data.data.payment_type = this.paymentType;
                        res.data.data.transaction_type = 'cable';
                        res.data.data.purchasePhone = this.phoneNumber;
                        res.data.data.decoder_no = this.decoderNumber; 
                        res.data.data.vend_type = this.package; 
                        res.data.data.statutory_charge = this.statutoryCharge;
                        res.data.data.customerName = this.verifiedData.name; 
                        res.data.data.address = this.verifiedData.address; 
                        res.data.data.reward = this.rewardObject;
                        // this.$refs.successfulPaymentMade.setDataAirtime(this.billObject);  
                        this.$root.$refs.openSuccess.openSuccessModal();
                        this.$refs.successfulPaymentMade.setDataSuccess(res.data);
                        this.statutoryCharge = null;

                    }
                })
                .catch(err => {
                    console.log("ERROR", err);
                    this.loading = false;
                });
            } finally {
            // console.log("Closed connection");
            }
        },
        async requery(requeryId) {
            this.loading = true
            try {
                await Api.getRequest(`requery-bill/${requeryId}`)
                .then(res => {
                this.loading = false;
                if(res.data.requery == 'yes') {
                    this.loading = true;
                    return this.requery(res.data.requery_id)
                }
                if (res.data.error) {
                    return this.$store.commit("setApiFailed", res.data.error);
                }
                if (res.data.success) {
                    this.loading = false;
                    this.billsHook();
                    this.$store.commit("setApiSuccess", "success");
                    res.data.data.payment_type = this.paymentType;
                    res.data.data.transaction_type = 'cable';
                    res.data.data.purchasePhone = this.phoneNumber;
                    res.data.data.decoder_no = this.decoderNumber; 
                    res.data.data.vend_type = this.package; 
                    res.data.data.statutory_charge = this.statutoryCharge;
                    res.data.data.customerName = this.verifiedData.name; 
                    res.data.data.address = this.verifiedData.address; 
                    res.data.data.reward = this.rewardObject;
                    // this.$refs.successfulPaymentMade.setDataAirtime(this.billObject);  
                    this.$root.$refs.openSuccess.openSuccessModal();
                    this.$refs.successfulPaymentMade.setDataSuccess(res.data); 
                }
                })
                .catch(err => {
                    // this.loader2 = false;
                    this.loading = false;
                });
            } finally {
            // console.log("Closed connection");
            }
        },
        billsHook() {
            Api.getRequest(`bills-hook`).then((res) => {
            }).catch(err => {
                this.loading = false;
            });
        },
        async openConfirmation() {
            // this.loading = true;
            
            if (this.statutoryCharge == null) {
                await this.verifySmartCardNumber();
            }
            else {
                this.confirmatiomModalValidation();
            }
        },
        confirmatiomModalValidation() {
            if (this.decoderNumber == "") {
                return this.$store.commit("setApiFailed", "Enter decoder number");
            }
            if (this.package == "") {
                return this.$store.commit("setApiFailed", "Select package");
            }
            if (this.optionData == "") {
                return this.$store.commit("setApiFailed", "Select disco");
            }

            if (this.signleDeal.amount == '') {
                return this.$store.commit("setApiFailed", "Choose data type");
            }
            this.billObject.amount = Number(this.signleDeal.amount);
            this.billObject.paymentType = "cable"
            this.billObject.paymentMethod = "safe";
            this.billObject.vend_type = this.package;
            this.billObject.statutory_charge = this.statutoryCharge;
            this.billObject.phone = this.phoneNumber;
            this.billObject.decoder_no = this.decoderNumber;
            this.billObject.cover_points = this.coverPoints;
            this.billObject.disco = this.optionData;
            this.billObject.customerName = this.verifiedData.name; 
            this.billObject.address = this.verifiedData.address; 
            this.billObject.reward = this.rewardObject;
            this.$refs.confirmModalBill.setDataSuccess(this.billObject); 
            this.$root.$refs.openConfirm.openConfirmationModal();
        },
        async fetchReward() {
            try {
                await Api.getRequest(`shelta-rewards`).then(res => {
                if (res.data.error) {
                    return this.$store.commit("setApiFailed", res.data.error);
                }
                if (res.data.success) {
                   this.rewardObject = res.data;
                   this.fetchSafeData();
                }
                })
                .catch(err => {
                    console.log("ERROR", err)
                    // this.loader2 = false;
                    this.loading = false;
                });
            } finally {
            // console.log("Closed connection");
            }
        },
        async fetchSafeData() {
            try {
                await Api.getRequest(`fetchsafedata`)
                .then(res => {
                    if (res.data.success) {
                        console.log("Safe data", res);
                        this.safeDetails = res.data;   
                    }
                    if (res.data.error) {
                    this.$store.commit("setApiFailed", "Can not read safe data");
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            } finally {
                // console.log("Closed connection");
            }
        }, 
    },
}
    
</script>


<style scoped lang="scss">
.bills-text {
    font-family: Lato;
    font-weight: 600;
    font-size: 20px;
    line-height: 60px;
    text-align: left;
    color: #1A1A1A;
    margin-top: 40px;
    span {
        font-size: 18px;
        margin-right: 20px;
        cursor: pointer;
    }
}

.history-text {
    font-family: Lato;
    font-weight: 400;
    font-size: 16px;
    line-height: 60px;
    color: #4688F4;
    cursor: pointer;
    margin-top: 40px;

}

label {
    font-family: Lato;
    font-weight: 500;
    font-size: 16px;
    color: #555555;
    text-align: left;
    display: flex;
}

select {
    box-shadow: none !important;
    outline: 0 !important;
    height: 48px;
    border: none;
    padding-left: 0;
    font-family: Lato;
    font-weight: 500;
    color: #555555;
    font-size: 16px;
    

}
.provider-holder {
    background: #ffffff;
    padding: 24px 8px 16px 8px;
    border-radius: 12px;
}


.custom-dropdown {
  position: relative;
//   width: 250px;
}

.selected-option {
  padding: 10px;
  border: 1px solid #E6E9EC;;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border-radius: 4px;
  font-family: Lato;
  font-weight: 500;
  font-size: 14px;
  text-transform: uppercase;
}

.options-panel {
//   display: none; /* Hidden by default */
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  border: 1px solid #ccc;
  background: #fff;
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;

  font-family: Lato;
  font-weight: 500;
  font-size: 16px;

}

.options-panel li {
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.options-panel li:hover {
  background-color: #f0f0f0;
}

/* Class to show the panel */
.show {
  display: block;
}

input {
    height: 48px;
    border-radius: 4px;
//   border: 1px solid #e7e7e7;
    border: 1px solid #ccc;
    background: #F8F9FA !important;
    border: none;
//   color: #aaadba;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    outline: 0 !important;
    box-shadow: none !important;
}
.beneficiries {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    span {
        color: #555555;
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        cursor: pointer;
    }
}
.ben-holder {
    display: flex;
    align-items: center;
    margin-top: 10px;
    label {
        margin-bottom: 0;
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        color: #9CA3AF;

    }
}
ul {
  list-style-type: none;
  margin: 10px;
  padding: 10px;
  height: 100px;
  overflow: scroll;
  li {
    font-family: Lato;
    font-size: 18px;
    color: #555555;
    cursor: pointer;
    padding: 10px;
  }
}
ul li:nth-child(odd) {
  background-color: #ffffff; /* Color for odd rows */
}

ul li:nth-child(even) {
  background-color: #f2f2f2; /* Color for even rows */
}
#savebeneficiaris {
    height: 17px;
    width: 17px;
    margin-right: 10px;
    cursor: pointer;
}
.deals-holder:hover {
    border: 1px solid #e1e1e1;
}
.activeDeals {
    // border: 1px solid #FFB100 !important;
    border: 1px solid #9f9f9f !important;
}
.deals-holder {
    display: flex;
    justify-content: space-between;
    border-radius: 8px;
    padding: 15px;
    background: #F8F9FA;
    border: 1px solid #F8F9FA;
    min-height: 168px;
    margin-bottom: 15px;
    gap: 20px;
    cursor: pointer;
    h6, h5 {
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        line-height: 30px;
        color: #555555;
        text-align: left;
    }
    h6 {
        color: #555555;
    }
    h5 {
        color: #1A1A1A;
    }
    p {
        margin-bottom: 0;
        // background: #FFB1001A;
        font-family: Lato;
        font-weight: 500;
        // color: #FFB100;
        background: #e7e7e7;
        color: #1A1A1A;
        font-size: 14px;
        padding: 4px 8px;
        border-radius: 50px;
        white-space: nowrap;
    }
}

.amount-holder, .payment-method-holder {
    background: #ffffff;
    padding: 24px 8px 16px 8px;
    border-radius: 12px;
    margin-top: 30px;
}

.amount-box {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    
}
.amount-item {
    background: #F8F9FA;
    padding: 12px 8px;
    border-radius: 8px;
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    margin-bottom: 20px;
    cursor: pointer;
}
.amount-item:hover {
    background: #e5e5e6;
}

.amount-item:not(:last-child) {
    margin-right: 15px;
}

.paymentOfPayment {
    // display: flex;
    margin-top: 30px;
}
.payment-item {
    display: flex;
    align-items: center;
    border: 1px solid #E6E9EC;
    padding: 16px;
    gap: 8px;
    border-radius: 6px;
    height: 75px;
    margin-bottom: 10px;
    cursor: pointer;
    // width: 50%;
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 17px;
        // line-height: 100%;
       color: #1A1A1A;
        text-align: left;
        margin-bottom: 0;
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 15px;
        // line-height: 100%;
        color: #555555;
        text-align: left;
        margin-bottom: 0;
        span {
            color: #4688F4;
        }
    }
}
.payment-item:hover {
    border: 1px solid #0033EA;
}
.active-payment {
    border: 1px solid #0033EA;
}

.submitPayment {
    margin-top: 40px;
    button {
        background: #0033EA;
        color: #ffffff;
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        width: 100%;
        height: 48px;
        outline: 0;
        box-shadow: none;
    }
}

.verify-data {
    margin-top: 6px;
    margin-bottom: 20px;
    h4 {
        font-family: Lato;
        text-align: left;
        color: #555555;
        font-size: 16px;
        font-weight: 600;
    }
}

.verify-smartcard {
    position: relative;
    button {
        position: absolute;
        top: 10px;
        right: 8px;
        background: #0033EA;
        color: #Ffff;
        height: 30px;
        padding: 2px 15px;
        outline: 0;
        box-shadow: none;
    };
}

/* For Chrome, Safari, Edge, and Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0; /* Removes a small margin in older Chrome versions */
}

/* For Firefox */
input[type=number] {
    -moz-appearance: textfield;
}

/* Optional: Combine into a class for specific inputs */
.no-spinners::-webkit-outer-spin-button,
.no-spinners::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.no-spinners {
    -moz-appearance: textfield;
    appearance: textfield; /* Standard property (works in newer browsers) */
}

@media only screen and (max-width: 599px) {
    .verify-smartcard {
        button {
            padding: 2px 6px;
            font-size: 12px
        };
    }
}

</style>